import React from "react";
import { usePageContent } from '../../hooks/usePageContent';

const AccessibilityPage = () => {
  const { find } = usePageContent('accessibility');
  const c = find('richText') || {};
  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{c.pageTitle || 'Accessibility'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        <div className="rich-text" dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }} />
      </div>
    </div>
  );
};

export default AccessibilityPage;
